module.exports = __webpack_public_path__ + "img/76048.e884ef76.svg";